import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import Search from 'components/Search';
import UserList from 'components/UserList';

import { makeAfter, withData } from 'lib';
import { UserListPageQuery } from '__generated__/UserListPageQuery.graphql';

const query = graphql`
  query UserListPageQuery($first: Int!, $after: String, $search: String) {
    ...UserList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<UserListPageQuery>;
};

const UserListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<UserListPageQuery>(query, preloadedQuery);

  return (
    <Page breadcrumbs={[{ name: 'Vartotojai' }]}>
      <Pagination>
        <Search>
          <UserList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<UserListPageQuery>({
  query,
  reloadOnRender: false,
  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(UserListPage);
